/** 本文件由工具自动生成,请勿手动修改！ **/
// @ts-nocheck
import { useState,  useEffect } from 'react';
import * as R from 'ramda';
import Request, { YWRequestConfig } from '@ywfe/request';
import { getHost, reduceParams, parseParams, querystring } from '@ywfe/utils';


const { basePath = '', loginPath = '' } = getHost("PROAUTH", "446")


  
    
export interface API58786Item {
  
  /** 分类名 */
  categoryName?: string;
  
  /** 分类值 */
  categoryCode?: string;
  
};
    
  



  export type API58786Req = {};



export interface API58786Res {
  /**   */
  code?: string;
  /**   */
  msg?: string;
  /**   */
  success?: boolean;
  /** WorkTaskTagActiveCountVO  */
  data?: API58786Item[];
  /**   */
  exceptionMsg?: string;
  
};


// 58786 查询标签分类

export interface IUseGetAPI58786Return {
  /** 查询标签分类: 接口请求状态 */
  isAPI58786Loading: boolean;
  /** 查询标签分类: 接口请求返回数据 */
  dataAPI58786: API58786Res;
  /**  查询标签分类: 接口数据请求方法 */
  fetchAPI58786Data:  ( config?: YWRequestConfig) => Promise<API58786Res>;
  /** 查询标签分类: 接口请求URL */
  requestUrl: string;
}

export const useGetAPI58786 = ():IUseGetAPI58786Return => {
  let isMount = true;
  const [isAPI58786Loading, setIsAPI58786Loading] = useState(false);
  const [dataAPI58786, setDataAPI58786] = useState<API58786Res>({} as API58786Res);
  const requestUrl = `${basePath}/team-work/workTask/getTaskTags`;

  const fetchAPI58786Data = async ( config?: YWRequestConfig): Promise<API58786Res> => {
  
    if ( isMount ) {
      setIsAPI58786Loading(true);
    }

    try {
      
      
      const res: any = await Request.get<API58786Res>(`${basePath}/team-work/workTask/getTaskTags`, {
        loginHost: loginPath,
        ...config
      });
      
      
      
      if (isMount) {
        setDataAPI58786(res || {} as API58786Res);
        setIsAPI58786Loading(false);
      }
      return res;
    } catch (error) {
      console.error('[ERROR] API Request Error: ', error);
      if ( isMount ) {
        setIsAPI58786Loading(false);
      }
      return false as unknown as API58786Res;
    }
  }

  useEffect(() => {
    return () => {
      isMount = false;
    };
  }, []);

  return {
    isAPI58786Loading,
    dataAPI58786,
    fetchAPI58786Data,
    requestUrl,
  }
}

